import { urlBaseRanking } from "./config";
const urlBase = urlBaseRanking;
import axiosInstance from "../services/config/axiosinstance";

function getConfigurations({
  id,
  jwt,
  offset = 1,
  limit = 10,
  search = "",
  columnSearch = "",
}) {
  var config = {
    method: "get",
    url: `${urlBase}/events/${id}/configurations/?offset=${offset}&limit=${limit}&search=${search}&columnSearch=${columnSearch}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

function createConfiguration(data) {
  var dataForm = JSON.stringify(data);

  var config = {
    method: "post",
    url: `${urlBase}/events/${data.idEvent}/configurations`,
    headers: {
      "Content-Type": "application/json",
    },
    data: dataForm,
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

function editConfiguration(data) {
  var dataForm = JSON.stringify(data);

  var config = {
    method: "put",
    url: `${urlBase}/configurations/${data.id}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: dataForm,
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

function deleteConfiguration(id, jwt) {
  var config = {
    method: "delete",
    url: `${urlBase}/configurations/${id}`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

async function deleteAllConfiguration(eventId) {
  var config = {
    method: "delete",
    url: `${urlBase}/configurations/${eventId}/event`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}
function getAllRanking({ id, jwt, offset, limit, search, columnSearch = "" }) {
  var config = {
    method: "get",
    url: `${urlBase}/events/${id}/ranking/?offset=${offset}&limit=${limit}&search=${search}&columnSearch=${columnSearch}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

// `code` é opcional: sem ele a api devolve o extrato de todas as
// configurações, como sempre. com ele, só as pontuações daquele código
async function getEarnedPoints({ loginId, eventId, jwt, offset, limit, code }) {
  const codeParam = code ? `&code=${encodeURIComponent(code)}` : "";

  var config = {
    method: "get",
    url: `${urlBaseRanking}/events/${eventId}/logins/${loginId}/earnedpoints?offset=${offset}&limit=${limit}${codeParam}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

// pontuar
async function createEarnedPoints(dataRanking, event, login) {
  const data = JSON.stringify({ ...dataRanking });
  var config = {
    method: "post",
    url: `${urlBaseRanking}/events/${event}/logins/${login}/earnedpointcreate`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

async function deleteEarnedPointById(id) {
  var config = {
    method: "delete",
    url: `${urlBase}/earnedpoint/${id}`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}
// zerar ranking do evento
async function deleteRankingEvent(eventId) {
  var config = {
    method: "delete",
    url: `${urlBaseRanking}/events/${eventId}/ranking`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

// apagar pontos de um usuário
async function deleteUserPoints(eventId, userId) {
  var config = {
    method: "delete",
    url: `${urlBaseRanking}/events/${eventId}/login/${userId}/ranking`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

// ranking de uma configuração de pontuação (tela Games X-Squad). devolve o
// mesmo shape de getAllRanking mais attempts/duration, estes vindos da partida
// registrada em games_xsquad — nulos para quem pontuou sem jogar
function getRankingByConfiguration({
  eventId,
  code,
  offset = 1,
  limit = 10,
  search = "",
  columnSearch = "name",
}) {
  const config = {
    method: "get",
    url: `${urlBaseRanking}/events/${eventId}/configurations/${encodeURIComponent(
      code,
    )}/ranking/?offset=${offset}&limit=${limit}&search=${search}&columnSearch=${columnSearch}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

// os N participantes com mais pontuações registradas em uma configuração, para
// o gráfico de barras da tela Games X-Squad. devolve { data: [{ loginId, name,
// total }] }, sem `count`: é uma lista fechada, não uma página.
//
// `total` aqui é a QUANTIDADE de pontuações, não a soma de pontos — é o que
// diferencia este endpoint do getRankingByConfiguration, que soma
function getTopRankingByConfiguration({ eventId, code, limit = 30 }) {
  const config = {
    method: "get",
    url: `${urlBaseRanking}/events/${eventId}/configurations/${encodeURIComponent(
      code,
    )}/ranking/top?limit=${limit}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

// apaga a pontuação do participante apenas naquela configuração: ajusta o
// total do ranking geral e remove a partida de games_xsquad. diferente de
// deleteUserPoints, que apaga tudo do participante no evento
function deleteRankingByConfiguration({ eventId, loginId, code }) {
  const config = {
    method: "delete",
    url: `${urlBaseRanking}/events/${eventId}/logins/${loginId}/configurations/${encodeURIComponent(
      code,
    )}/ranking`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

export {
  getConfigurations,
  createConfiguration,
  editConfiguration,
  deleteConfiguration,
  deleteAllConfiguration,
  deleteEarnedPointById,
  getAllRanking,
  getEarnedPoints,
  createEarnedPoints,
  deleteRankingEvent,
  deleteUserPoints,
  getRankingByConfiguration,
  getTopRankingByConfiguration,
  deleteRankingByConfiguration,
};
